export const CASE_STUDIES = [
  {
    slug: "solo-agent-georgia",
    client: "The solo agent drowning in admin",
    location: "Georgia",
    tag: "Solo agent → team of 4",
    result: "22 hrs/week reclaimed",
    summary: "A top-producing solo agent was buried in admin and follow-up. Their Quexify right hand took over ops, lead response, and transaction coordination, freeing them to recruit and scale to a four-agent team in six months.",
    quote: "I hired a right hand and got my business back. Six months later I'm running a team.",
    author: "Solo agent, Georgia",
    metrics: [
      { k: "Hours saved / wk", v: "22" },
      { k: "Speed-to-lead", v: "4x faster" },
      { k: "Deals closed", v: "+38%" },
    ],
    full: [
      "Before Quexify, every evening ended the same way: a backlog of follow-ups, half-updated files, and a calendar that fought back. Growth felt impossible because there was no time to grow.",
      "We embedded a right hand trained on their exact stack. Within two weeks, lead response, transaction coordination, and marketing cadence ran without the founder touching them.",
      "The result wasn't just hours saved. With the busywork gone, they recruited, trained, and scaled into a four-agent team, all while closing 38% more deals.",
    ],
  },
  {
    slug: "boutique-brokerage-north-carolina",
    client: "The brokerage losing deals to detail",
    location: "North Carolina",
    tag: "Boutique brokerage",
    result: "Zero missed deadlines in 12 months",
    summary: "A boutique luxury brokerage kept losing hours to disclosure chases and calendar chaos. We embedded operators across their agents and standardized coordination and marketing.",
    quote: "Nothing slips anymore. Our agents finally trust the process behind the deal.",
    author: "Managing broker, North Carolina",
    metrics: [
      { k: "Missed deadlines", v: "0" },
      { k: "Agent NPS", v: "+27" },
      { k: "Marketing output", v: "3x" },
    ],
    full: [
      "A luxury brand lives and dies on details. The brokerage's agents were losing those details to manual chasing and a patchwork of tools.",
      "Quexify standardized transaction coordination across the brokerage and automated the marketing cadence, giving every agent the same reliable operational spine.",
      "Twelve months in: zero missed deadlines, a 27-point jump in agent satisfaction, and three times the marketing output.",
    ],
  },
  {
    slug: "growing-team-maryland",
    client: "The team that needed leverage, not payroll",
    location: "Maryland",
    tag: "Growing team",
    result: "$180k of agent time returned / yr",
    summary: "A fast-growing team needed leverage without more overhead. Their embedded right hand ran the calendar, worked leads, and drove deals to close.",
    quote: "It's like adding a full-time salary back to the team, without adding a salary.",
    author: "Team lead, Maryland",
    metrics: [
      { k: "Time value returned", v: "$180k" },
      { k: "Appointments booked", v: "+61%" },
      { k: "Fall-through rate", v: "-44%" },
    ],
    full: [
      "Scaling a team usually means scaling overhead. This team wanted leverage without the payroll.",
      "Their embedded right hand took over the calendar, lead work, and deal coordination, booking 61% more appointments and cutting fall-throughs nearly in half.",
      "Measured in reclaimed agent time, the engagement returned the equivalent of a full-time salary over the year.",
    ],
  },
  {
    slug: "independent-agent-georgia",
    client: "The agent who couldn't switch off",
    location: "Georgia",
    tag: "Independent agent",
    result: "First full weekend off in 3 years",
    summary: "Beyond the numbers: with ops, leads, and coordination handled, the agent took their first uninterrupted weekend off in three years.",
    quote: "I took a real weekend off for the first time in years. Not one deal skipped a beat.",
    author: "Independent agent, Georgia",
    metrics: [
      { k: "Hours saved / wk", v: "18" },
      { k: "Response time", v: "< 5 min" },
      { k: "Client rating", v: "4.9/5" },
    ],
    full: [
      "Success had quietly turned into a trap: more clients meant more chasing, and the business couldn't run without the founder online.",
      "Quexify took over the operational load, ops, leads, coordination, and follow-up, with sub-five-minute lead response and a human reviewing everything.",
      "The proof wasn't a metric. It was the first full, uninterrupted weekend off in three years, with every deal still moving.",
    ],
  },
];

export const TESTIMONIALS = CASE_STUDIES.map((c) => ({ quote: c.quote, author: c.author }));
